@if (data) {
  <div class="section-metadata">
    <ti-status
      *ngIf="data?.status"
      [statusId]="statusId"
      [status]="statusName"
      [topicTypeId]="TopicTypeId.WorkflowStatus"></ti-status>
    <div class="section-metadata--text" [innerHTML]="text"></div>
  </div>
}
